let config: Record<string, any> = {
};

export const setConfig = (newConfig: Record<string, any>) => {
    config = { ...config, ...newConfig };
};

export const getConfig = () => {
    return config;
};
